// @flow
import { MaterialCategory } from '../../../../../enum/Material';
import { Gabion } from './Gabion';
import { MacMat } from './MacMat';
import { Reno } from './Reno';
import { RipRap } from './RipRap';
import { useFormikContext } from 'formik';
import { IFormikForm } from '../ModalMaterial/FormikMaterial';
import Natural from './Natural';
import Concrete from './Concrete';
import { RenoStandard } from './RenoStandard';
import { EConversionSIToImperial, convertTo } from '../../../../../conversion';
export interface IFactoryMaterialProps {}

export interface IDropdownOption {
    label: string;
    value: string | number;
}

enum EDropdownName {
    thickness = 'thickness',
    rockD50 = 'rockD50',
}

export const MaterialCategoryFactory = (props: IFactoryMaterialProps) => {
    const { values } = useFormikContext<IFormikForm>();
    let sector = values.sectorChannel;
    let cat = values[sector].category;
    switch (cat) {
        case MaterialCategory.Gabion:
            return <Gabion />;
        case MaterialCategory.Reno:
            if (values[values.sectorChannel].cu) {
                return <Reno />;
            } else {
                return <RenoStandard />;
            }
        case MaterialCategory.MacMat:
            return <MacMat />;
        case MaterialCategory.Riprap:
            return <RipRap />;
        case MaterialCategory.Cohesive:
        case MaterialCategory.Other:
            return <Natural />;
        case MaterialCategory.Concrete:
            // Rigid protection system: no physical-data inputs (thickness/rockD50/cu).
            // Shows only "use for all sectors" + editable roughness; allowed-shear stays hidden.
            return <Concrete />;
        default:
            return <></>;
    }
};

export const castToIDropdownOptionArray = (physicalData: any[], dropdownName: string, isImperial?: boolean): IDropdownOption[] => {
    let unique: Set<any> = new Set();
    switch (dropdownName) {
        case EDropdownName.thickness:
            unique = new Set(physicalData.map(data => data.thickness));
            break;
        case EDropdownName.rockD50:
            unique = new Set(physicalData.map(data => data.rockD50));
            break;
        default:
            unique = new Set(physicalData.map(data => data.cu));
            break;
    }
    let arr = Array.from(unique);
    if (arr[0] !== undefined) {
        return arr.map(option => {
            let _label =
                (dropdownName == EDropdownName.thickness || dropdownName == EDropdownName.rockD50) && isImperial ? convertTo(option, EConversionSIToImperial.m_to_in).toFixed(2) : option.toString();
            return { label: _label, value: option };
        });
    }
    return [];
};
